import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TrainRemark } from "../models/train-remark";
import { TrainConnectivity } from "../models/train-connectivity";


@Injectable({
    providedIn: 'root'
})
export class TrainConnectivityReportDataService {

    constructor(private http: HttpClient) { }

    getTrainConnectivities = (projectId: number, date: string | null): Observable<TrainConnectivity[]> => {
        return this.http.get<TrainConnectivity[]>(`${environment.api.baseUrl}/${environment.api.endpoints.trainConnectivity.connectivities}?projectId=${projectId}&date=${date && date.replace("+", "	%2B")}`);
    }

    getTrainConnectivity = (projectId: number, id: number): Observable<TrainConnectivity> => {
        return this.http.get<TrainConnectivity>(`${environment.api.baseUrl}/traincon/${id}?projectId=${projectId}`);
    }

    updateTrainConnectivity = (projectId: number, id: number, trainConnectivity: TrainConnectivity, date: string | null): Observable<any> => {
        return this.http.post(`${environment.api.baseUrl}/traincon/${id}?projectId=${projectId}&date=${date && date.replace("+", "	%2B")}`, {
            ...trainConnectivity
        });
    }

    updateAllTrainsConnectivities = (projectId: number, trainConnectivities: TrainConnectivity[], date: string | null): Observable<any> => {
        return this.http.put(`${environment.api.baseUrl}/traincon?projectId=${projectId}&date=${date && date.replace("+", "	%2B")}`,
            trainConnectivities
        );
    }


    getTrainRemarks = (projectId: number, date?: string | null): Observable<TrainRemark[]> => {
        if (date) {
            return this.http.get<TrainRemark[]>(`${environment.api.baseUrl}/${environment.api.endpoints.trainConnectivity
                .remarks}/date/${projectId}?date=${date && date.replace("+", "	%2B")}`);
        } else {
            return this.http.get<TrainRemark[]>(`${environment.api.baseUrl}/${environment.api.endpoints.trainConnectivity
                .remarks}/${projectId}`);
        }
    }

    getTrainRemark = (projectId: number, id: number): Observable<TrainRemark> => {
        return this.http.get<TrainRemark>(`${environment.api.baseUrl}/${environment.api.endpoints.trainConnectivity
            .remark}/${id}?projectId=${projectId}`);
    }

    addTrainRemark = (projectId: number, trainRemark: TrainRemark): Observable<any> => {
        return this.http.post(`${environment.api.baseUrl}/newtrainremark/${projectId}`, {
            ...trainRemark
        });
    }

    updateTrainRemark = (projectId: number, id: number, trainRemark: TrainRemark): Observable<any> => {
        return this.http.post(`${environment.api.baseUrl}/trainremark/${id}?projectId=${projectId}`, {
            ...trainRemark
        });
    }

    deleteTrainRemark = (id: number, projectId: number): Observable<any> => {
        return this.http.delete(`${environment.api.baseUrl}/trainremark/${id}?projectId=${projectId}`);
    }
}